import React from 'react'
import {
    BrowserRouter as Router,
    Switch,
    Route
} from 'react-router-dom'

import Navigation from './Navigation'
import Footer from './Footer'
import LandingPage from './Landing'
import SignUpPage from './userManagement/SignUp'
import SignInPage from './userManagement/SignIn'
import PasswordForgetPage from './userManagement/PasswordForget'
import DashboardPage from './pages/Dashboard'
import AccountPage from './pages/Account'
import IntroQuestionsPage from './pages/IntroQuestions'
import IntroQuestionsSuccessPage from './pages/IntroQuestionsSuccess'
import SettingsPage from './pages/Settings'
import NotFoundPage from './pages/NotFound'
import PlantDetailsPage from './pages/PlantDetails'
import PlantListPage from './pages/PlantList'
import DeviceListPage from './pages/DeviceList'
import DeviceDetailsPage from './pages/DeviceDetails'
import ClassifierPage from './pages/Classifier'
import PlantClassificationPage from './pages/PlantClassification'
import { ContentContainer } from './StyledComponents/Fillers'

import * as routes from '../constants/routes'

import withAuthentication from './higherOrder/withAuthentication'

const App = () =>
    (
        <Router>
            <div>
                <Navigation />

                <ContentContainer className="container">
                    <Switch>
                        <Route exact path={routes.LANDING} component={() => <LandingPage />} />
                        <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
                        <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
                        <Route
                            exact
                            path={routes.PASSWORD_FORGET}
                            component={() => <PasswordForgetPage />}
                        />
                        <Route exact path={routes.DASHBOARD} component={DashboardPage} />
                        <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
                        <Route
                            exact
                            path={routes.INTRO_QUESTIONS}
                            component={() => <IntroQuestionsPage />}
                        />
                        <Route
                            exact
                            path={routes.INTRO_QUESTIONS_SUCCESS}
                            component={() => <IntroQuestionsSuccessPage />}
                        />
                        <Route
                            exact
                            path={routes.PLANT_CLASSIFICATION}
                            component={() => <PlantClassificationPage />}
                        />
                        <Route
                            exact
                            path={routes.CLASSIFIER}
                            component={() => <ClassifierPage />}
                        />
                        <Route exact path={routes.SETTINGS} component={() => <SettingsPage />} />
                        <Route path={routes.PLANT} component={PlantDetailsPage} />
                        <Route exact path={routes.PLANTS} component={PlantListPage} />
                        <Route
                            exact
                            path={routes.SENSOR_DEVICE}
                            component={props => <DeviceDetailsPage type="sensor" {...props} />}
                        />
                        <Route
                            exact
                            path={routes.VALVE_DEVICE}
                            component={props => <DeviceDetailsPage type="valve" {...props} />}
                        />
                        <Route exact path={routes.DEVICES} component={DeviceListPage} />
                        <Route component={() => <NotFoundPage />} />
                    </Switch>
                </ContentContainer>

                <Footer />
            </div>
        </Router>
    )

export default withAuthentication(App)



// WEBPACK FOOTER //
// ./src/components/App.js